export enum PaymentType
{
    Credit = 0,
    Refund,
    PartialRefund
}